import type { AudioCaptureActionsProviderProps } from "./audio-capture-actions.types";
import { AudioCaptureActionsProvider } from "./audio-capture-actions.provider";
import { AudioCaptureActionsContent } from "./audio-capture-actions-content";

type AudioCaptureActionsProps = Pick<AudioCaptureActionsProviderProps, "noteId" | "onRequestClose">;

export function AudioCaptureActions({ noteId, onRequestClose }: AudioCaptureActionsProps) {
  return (
    <AudioCaptureActionsProvider noteId={noteId} onRequestClose={onRequestClose}>
      <AudioCaptureActionsContent />
    </AudioCaptureActionsProvider>
  );
}
